import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import isValid from 'date-fns/isValid';
import format from 'date-fns/format';

// eslint-disable-next-line import/prefer-default-export
export const RenderDatePicker = ({ input, className, placeholder, popperPlacement, popperModifiers, isClearable, dateFormat, maxDate, minDate, id }) => {
  const [startDate, setStartDate] = React.useState(isValid(moment(input.value, dateFormat.toUpperCase()).toDate()) ? moment(input.value, dateFormat.toUpperCase()).toDate() : null);

  let placeholderClass = '';
  function onHandleKeyDown(e) {
    if (e.keyCode === 8 || e.keyCode === 46) {
      setStartDate(null);
      input.onChange(null);
    }
  }

  function applicablePlaceholder() {
    if (input.value && !isValid(moment(input.value, dateFormat.toUpperCase()).toDate())) {
      placeholderClass = 'dark-placeholder-text ';
      return input.value;
    }
    return placeholder;
  }

  React.useEffect(() => {
    setStartDate(isValid(moment(input.value, dateFormat.toUpperCase()).toDate()) ? moment(input.value, dateFormat.toUpperCase()).toDate() : null);
  }, [input.value]);

  return (
    <DatePicker
      placeholder={ applicablePlaceholder() }
      fixedHeight
      showMonthDropdown
      placeholderText={ applicablePlaceholder() }
      maxDate={ maxDate }
      minDate={ minDate }
      popperPlacement={ popperPlacement }
      popperModifiers={ popperModifiers ?? {
        preventOverflow: {
          enabled: true,
          escapeWithReference: true,
          boundariesElement: 'viewport'
        }
      } }
      autoComplete="off"
      isClearable={ isClearable }
      showYearDropdown
      dropdownMode="select"
      className={ placeholderClass + (className === '' ? 'form-select' : className) }
      dateFormat={ dateFormat }
      selected={ startDate }
      onKeyDown={ e => onHandleKeyDown(e) }
      onChange={ (date, e) => { setStartDate(date); input.onChange(format(date, dateFormat)); } }
      id={ id }
    />
  );
};

RenderDatePicker.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  popperPlacement: PropTypes.string,
  popperModifiers: PropTypes.oneOfType([PropTypes.shape, PropTypes.arrayOf(PropTypes.shape)]),
  isClearable: PropTypes.bool,
  dateFormat: PropTypes.string,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  id: PropTypes.string
};

RenderDatePicker.defaultProps = {
  placeholder: '',
  popperPlacement: 'bottom-start',
  popperModifiers: [],
  className: '',
  isClearable: false,
  dateFormat: 'MMM dd, yyyy',
  maxDate: null,
  minDate: null,
  id: null
};
